import { SOURCES_TYPE } from '@crm/types'
import { useLocales } from '@shared/locales'
import { Form, Input, Radio, Space } from 'antd'

export const FormNomenclaturesSources = () => {
  const { t } = useLocales()

  return (
    <>
      <Form.Item
        name="name"
        label={t('nomenclature.name')}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="source_type"
        label={t('nomenclature.source_type')}
        rules={[{ required: true }]}
      >
        <Radio.Group>
          <Space direction="vertical">
            <Radio value={SOURCES_TYPE.ONLINE}>
              {t('nomenclature.online')}
            </Radio>
            <Radio value={SOURCES_TYPE.OFFLINE}>
              {t('nomenclature.offline')}
            </Radio>
          </Space>
        </Radio.Group>
      </Form.Item>
    </>
  )
}
